import { connect } from 'react-redux';

import {
  getClientName,
  getShowAuthPopup,
  getAvatar,
  getClientBonusScore,
  getClientUnconfirmedPhone,
  getConfirmedAt,
  getIsLoggedIn,
} from 'src/store/client/selectors';

import {
  showAuthAction,
  hideAuthAction,
  logInAction,
  onLoadAction,
  signUpAction,
  logOutAction,
  setClientConfirmPhone,
  showLogOutAction,
  hideLogOutAction,
} from 'src/store/client/actions';

import { getIsHomepage, getIsWhitelabel } from 'src/store/view/selectors';
import {
  sendMindboxAuthAction,
  sendMindboxRegistrationAction,
} from 'src/store/mindbox/actions';

import HeaderAuth from './HeaderAuth';

const mapStateToProps = () => (state) => ({
  isOpen: getShowAuthPopup(state),
  clientName: getClientName(state),
  clientAvatar: getAvatar(state),
  clientUnconfirmedPhone: getClientUnconfirmedPhone(state),
  isConfirmedClientEmail: getConfirmedAt(state),
  bonusScore: getClientBonusScore(state),
  isWhiteLabel: getIsWhitelabel(state),
  isHomepage: getIsHomepage(state),
  isLoggedIn: getIsLoggedIn(state),
});

const mapDispatchToProps = {
  onShowAuthPopup: showAuthAction,
  onHideAuthPopup: hideAuthAction,
  onShowLogOutPopup: showLogOutAction,
  onHideLogOutPopup: hideLogOutAction,
  onLoad: onLoadAction,
  logIn: logInAction,
  mindboxAuth: sendMindboxAuthAction,
  signUp: signUpAction,
  mindboxRegistration: sendMindboxRegistrationAction,
  logOut: logOutAction,
  setConfirmedPhone: setClientConfirmPhone,
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderAuth);
